/*
 * @Author: wuxb wuxb@zghits.com
 * @Date: 2020-05-07 14:16:05
 * @LastEditors: wuxb wuxb@zghits.com
 * @LastEditTime: 2023-07-18 11:28:54
 * @FilePath: \official-website-app\src\App.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { Component } from "react";
import "./App.less";
import { Provider } from "react-redux";
import store from "./store";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
//import AuthorizedRoute from "./AuthorizedRoute";
import Routers from './routerMap';
//import { browserHistory } from 'react-router'; 
// 404页面
import NotFound from './notFound';
import { ConfigProvider  } from 'antd';
// import zh_CN from 'antd/lib/locale-provider/zh_CN';
// import moment from 'moment';
// import 'moment/locale/zh-cn';

let data=window.sessionStorage.getItem('dataInfo');
let dataInfo=data?JSON.parse(data):'{}';
// moment.locale('zh-cn');
class App extends Component {
    constructor(props) {
        super(props);
        let user = dataInfo==='{}'?'':dataInfo['loginUser']['user_name'];//getCookie('user_name');
        let pass = dataInfo==='{}'?'':dataInfo['loginUser']['password'];//getCookie('password');
        let isok = user !== '' && user !== undefined && pass !== '' && pass !== undefined;
        this.state = { token: isok, path: '' };
    }
    componentDidMount() {
        let user =  dataInfo==='{}'?'':dataInfo['loginUser']['user_name']//getCookie('user_name');
        let pass =  dataInfo==='{}'?'':dataInfo['loginUser']['password']//getCookie('password');
        let isok = user !== '' && user !== undefined && pass !== '' && pass !== undefined;
        this.setState({
            token: isok,
            path: window.location.pathname
        });
        //window.onbeforeunload = onbeforeunload_handler; 
        //window.onunload =onunload_handler; 
        //function onbeforeunload_handler(){ let warning = "确认退出?"; return warning; } 
        //function onunload_handler() { let warning = "谢谢光临"; alert(warning);
    }

    render() {
        const { token, path } = this.state;
        return (
            <ConfigProvider  >
                <div className="App">
                    <Provider store={store}>
                        <BrowserRouter forceRefresh={false}>
                            <Switch>
                                {Routers.map((item, index) => {
                                    return <Route key={index} path={item.path} exact={false} render={props =>
                                        (!item.auth ? (<item.component {...props} />) : (token ? <item.component {...props} /> : <Redirect to={{
                                            pathname: '/login',
                                            state: { from: props.location }
                                        }} />)
                                        )} />
                                })}
                                {path === '/' ? <Redirect to='/index' /> : path === '/index' ? <Redirect to='/index' /> : <Route component={NotFound} />}
                            </Switch>
                        </BrowserRouter>
                    </Provider>
                </div>
            </ConfigProvider >
        );
    }
}

export default (App);
